import { AlertModal, Loader } from '@/components/Common';
import { trpc } from '@/data-loaders';
import { useDisciplineList, useHandleError, useHandleSuccess } from '@/hooks';
import { useAwmsStore } from '@/store';
import { useEffect, useState } from 'react';

export const DisciplineListing = ({ selectedSchool }: { selectedSchool: number }) => {
  const sendToastDeleteDisciplineSuccess = useHandleSuccess({ title: 'Delete discipline' });
  const [alert, setAlert] = useState<boolean>(false);
  const [disciplineIdToDelete, setDisciplineIdToDelete] = useState<number>(0);

  const activeYear = useAwmsStore((state) => state.activeYear);
  const {
    data: disciplineList,
    isLoading: isDisciplineListLoading,
    error: disciplineListError,
  } = useDisciplineList(selectedSchool);
  const handleError = useHandleError();
  const trpcUtils = trpc.useUtils();

  const { mutate: deleteDisciplineMutation } = trpc.admin.deleteDiscipline.useMutation({
    onSuccess: () => {
      trpcUtils.schoolUnit.getDisciplineBySchoolIdList.invalidate();
      trpcUtils.schoolUnit.getDisciplineBySchoolIdList.refetch();
      sendToastDeleteDisciplineSuccess();
    },
  });

  useEffect(() => {
    if (disciplineListError) {
      console.error('Error fetching school list:', { disciplineListError });
      handleError([disciplineListError]);
    }
  }, [handleError, disciplineListError]);
  if (isDisciplineListLoading) {
    return <Loader />;
  }
  return (
    <div className="w-96">
      <AlertModal
        title="Do you want to remove this discipline?"
        description="This will permanently delete the discipline and update the related academics data."
        confirmAction={() => {
          setAlert(false);
          deleteDisciplineMutation({ disciplineId: disciplineIdToDelete, year: activeYear });
        }}
        open={alert}
        cancelAction={() => {
          setAlert(false);
        }}
      />
      <div className="mt-4 flex flex-col gap-2">
        <div className="mt-4">
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2">Discipline</th>
                <th className="border border-gray-300 px-4 py-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {disciplineList?.map((discipline) => {
                return (
                  <tr key={discipline.id} className="border-t">
                    <td className="border-2 px-4 py-2">{discipline.name}</td>
                    <td
                      className="cursor-pointer border-2 px-4 py-2 text-b2 font-semibold text-deep-blue underline"
                      onClick={() => {
                        setAlert(true);
                        setDisciplineIdToDelete(discipline.id);
                      }}
                    >
                      Delete discipline
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
